module.exports = __webpack_public_path__ + "510943c7df0d9cf9dd7938dd62b09ae2.png";